import type { EnrichedDialerData } from "@/features/PowerDialer/CentralPanel/ListTable"

export function mergeContactData(originalItem: any, chatStoreContact: any, id: string | null) {
  const safeOriginalItem = originalItem ?? {}
  const safeChatStoreContact = chatStoreContact ?? {}

  let cleanedObj = {}

  // Preserve the original dialer list item's id - this is the canonical contact ID
  // that should be used for API calls. The sync data's id might be different.
  const originalId = safeOriginalItem.id
  // Preserve the original phone from the dialer list item - don't enrich from contact map sync
  const originalPhone = safeOriginalItem.phone

  if (id && safeChatStoreContact?.raw) {
    // Merge original item data with chat store data, prioritizing chat store for conflicts
    cleanedObj = {
      ...safeOriginalItem, // Keep original data as base
      ...safeChatStoreContact.raw, // Override with chat store data
    }
    // Restore the original id from the dialer list item to ensure correct API calls
    if (originalId !== undefined) {
      cleanedObj = { ...cleanedObj, id: originalId }
    }
    // Restore the original phone from the dialer list item - the list determines which phone to dial
    if (originalPhone !== undefined) {
      cleanedObj = { ...cleanedObj, phone: originalPhone }
    }
  } else {
    cleanedObj = {
      ...safeOriginalItem,
    }
  }

  cleanedObj = objCleaner(cleanedObj)

  cleanedObj = patcherAddress(cleanedObj)

  // cleanedObj = patcherLastNote(cleanedObj)

  return cleanedObj as EnrichedDialerData
}

function objCleaner(obj: any) {
  const copyObj = { ...obj }
  delete copyObj?.raw
  // delete copyObj?._id
  // delete copyObj?.remote
  delete copyObj?.tz_offset_millis
  delete copyObj?.customData

  return copyObj
}

function patcherAddress(obj: any) {
  const copyObj = { ...obj }

  let addressObj = copyObj?.address

  if (addressObj && typeof addressObj === "string" && addressObj.startsWith("[") && addressObj.endsWith("]")) {
    // It has this format:
    // "[postalCode:null, street:null, state:Québec, geocodeAccuracy:null, longitude:null, latitude:null, country:Canada, city:Montreal]"
    // We need to parse it and convert it to a beautiful string
    const addressString = addressObj
      .replace("[", "")
      .replace("]", "")
      .split(",")
      .map((item: string) => {
        const [key, value] = item.split(":")
        return `${key}: ${value}`
      })
      .join(", ")

    copyObj.address = addressString
  }

  return copyObj
}

// function patcherLastNote(obj: any) {
//   const copyObj = { ...obj }

//   let lastNoteObj = copyObj?.lastNote

//   if (lastNoteObj && typeof lastNoteObj === "object") {
//     copyObj.lastNote = `${lastNoteObj?.description} - ${lastNoteObj?.value} ${lastNoteObj?.url ? `- ${lastNoteObj?.url}` : ""}`
//   }

//   return copyObj
// }
